<template>
  <div>
    <div class="md-layout md-alignment-center" style="margin-bottom: 20px;">
      <div class="md-layout-item md-large-size-50 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
        <h2 style="text-align: center; line-height: 2em;">めしに行ける日をカレンダーから選んでください</h2>
        <v-calendar :is-expanded=true :attributes='attributes' @dayclick='dayClicked'></v-calendar>
      </div>
    </div>
    <template v-if="initialized && Object.keys(schedules).length == 0">
      <md-empty-state
        md-icon="date_range"
        md-label="まだ候補日がありません"
        md-description="めし行けそうな日を登録してください。">
      </md-empty-state>
    </template>
    <div class="md-layout md-alignment-center" v-if="initialized && Object.keys(schedules).length > 0">
      <div class="md-layout-item md-large-size-50 md-medium-size-70 md-small-size-100 md-xsmall-size-100">
        <md-table style="margin-bottom: 20px;">
          <md-table-row>
            <md-table-head>日付</md-table-head>
            <md-table-head>朝めし</md-table-head>
            <md-table-head>昼めし</md-table-head>
            <md-table-head>晩めし</md-table-head>
            <md-table-head></md-table-head>
          </md-table-row>
          <md-table-row v-for="(values, key, index) in schedules" :key='index'>
            <md-table-cell>{{Number(key) | toDateFormat}}</md-table-cell>
            <md-table-cell>{{values['morning']}}</md-table-cell>
            <md-table-cell>{{values['lunch']}}</md-table-cell>
            <md-table-cell>{{values['dinner']}}</md-table-cell>
            <md-table-cell>
              <md-button @click="editButtonClicked(Number(key))">編集</md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
        <md-button class="md-raised" @click="toMypage">マイページへ戻る</md-button>
      </div>
    </div>
    <md-dialog :md-active.sync='showDialog'>
      <md-dialog-title>{{ selectedDateTime | toDateFormat }}</md-dialog-title>
      <md-content>
        <md-list>
          <md-list-item style='background-color: rgb(246, 212, 216);'>
            <md-checkbox v-model="selectedMorning" :disabled="!selectedMorningEnable" class="md-primary text-bold">朝めし</md-checkbox>
          </md-list-item>
          <md-list-item style='background-color: rgb(200, 239, 234);'>
            <md-checkbox v-model="selectedLunch" :disabled="!selectedLunchEnable" class="md-primary text-bold">昼めし</md-checkbox>
          </md-list-item>
          <md-list-item style='background-color: rgb(252, 241, 211);'>
            <md-checkbox v-model="selectedDinner" :disabled="!selectedDinnerEnable"  class="md-primary text-bold">晩めし</md-checkbox>
          </md-list-item>
        </md-list>
      </md-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false">キャンセル</md-button>
        <md-button class="md-primary md-raised " @click="save">登録する</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import firebaseApp from '@/firebaseApp'
import router from '@/router'
import moment from 'moment'
import keySort from '@/utils/keySort'
const db = firebaseApp.firestore()
db.settings({ timestampsInSnapshots: true })
const schedulesRef = db.collection('schedules')
let data = {
  mornings: [],
  lunches: [],
  dinners: [],
  selectedDateTime: '',
  selectedMorning: false,
  selectedLunch: false,
  selectedDinner: false,
  selectedMorningEnable: true,
  selectedLunchEnable: true,
  selectedDinnerEnable: true,
  showDialog: false,
  userId: '',
  initialized: false
}

function openDialog (dateTime) {
  data.selectedMorning = false
  data.selectedLunch = false
  data.selectedDinner = false
  data.selectedMorningEnable = true
  data.selectedLunchEnable = true
  data.selectedDinnerEnable = true
  data.mornings.some(function (v, i) {
    if (v.dateTime === dateTime) {
      data.selectedMorning = true
      data.selectedMorningEnable = !v.reserveUserId
    }
  })
  data.lunches.some(function (v, i) {
    if (v.dateTime === dateTime) {
      data.selectedLunch = true
      data.selectedLunchEnable = !v.reserveUserId
    }
  })
  data.dinners.some(function (v, i) {
    if (v.dateTime === dateTime) {
      data.selectedDinner = true
      data.selectedDinnerEnable = !v.reserveUserId
    }
  })
  data.selectedDateTime = dateTime
  data.showDialog = true
}

export default {
  created () {
    data.initialized = false
    data.userId = firebaseApp.auth().currentUser.uid
    data.mornings = []
    data.lunches = []
    data.dinners = []
    schedulesRef.where('userId', '==', data.userId).get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          switch (doc.data().type) {
            case 'morning':
              data.mornings.push(Object.assign(doc.data(), {id: doc.id}))
              break
            case 'lunch':
              data.lunches.push(Object.assign(doc.data(), {id: doc.id}))
              break
            case 'dinner':
              data.dinners.push(Object.assign(doc.data(), {id: doc.id}))
              break
          }
        })
        data.initialized = true
      })
      .catch(function (error) {
        console.log('Error getting documents: ', error)
      })
  },
  data () {
    return data
  },
  computed: {
    schedules () {
      const result = {}
      this.mornings.forEach(function (morning) {
        if (!result[morning.dateTime]) result[morning.dateTime] = {morning: '', lunch: '', dinner: ''}
        result[morning.dateTime]['morning'] = morning.reserveUserName ? morning.reserveUserName : '○'
      })
      this.lunches.forEach(function (lunch) {
        if (!result[lunch.dateTime]) result[lunch.dateTime] = {morning: '', lunch: '', dinner: ''}
        result[lunch.dateTime]['lunch'] = lunch.reserveUserName ? lunch.reserveUserName : '○'
      })
      this.dinners.forEach(function (dinner) {
        if (!result[dinner.dateTime]) result[dinner.dateTime] = {morning: '', lunch: '', dinner: ''}
        result[dinner.dateTime]['dinner'] = dinner.reserveUserName ? dinner.reserveUserName : '○'
      })
      return keySort(result)
    },
    attributes () {
      const morning = this.mornings.map(schedule => ({
        key: `schedule.${schedule.id}`,
        dot: {
          backgroundColor: 'rgb(227, 134, 146)'
        },
        dates: new Date(schedule.dateTime)
      }))
      const lunch = this.lunches.map(schedule => ({
        key: `schedule.${schedule.id}`,
        dot: {
          backgroundColor: 'rgb(100, 201, 155)'
        },
        dates: new Date(schedule.dateTime)
      }))
      const dinner = this.dinners.map(schedule => ({
        key: `schedule.${schedule.id}.dinner`,
        dot: {
          backgroundColor: 'rgb(240, 186, 50)'
        },
        dates: new Date(schedule.dateTime)
      }))
      return morning.concat(lunch).concat(dinner)
    }
  },
  filters: {
    toDateFormat: function (value) {
      if (!value) return ''
      return moment(new Date(value)).format('YYYY/MM/DD')
    }
  },
  methods: {
    toMypage: () => {
      router.push({name: 'Mypage'})
    },
    dayClicked: (day) => {
      openDialog(day.dateTime)
    },
    editButtonClicked: (dateTime) => {
      openDialog(dateTime)
    },
    save: () => {
      const dateTime = data.selectedDateTime
      const morningSchedule = data.mornings.find(s => s.dateTime === dateTime)
      if (data.selectedMorning && !morningSchedule) {
        schedulesRef.add({userId: data.userId, dateTime: dateTime, type: 'morning'}).then(function (docRef) {
          data.mornings.push({id: docRef.id, type: 'morning', userId: data.userId, dateTime: dateTime})
          data.showDialog = false
        })
      } else if (!data.selectedMorning && morningSchedule) {
        schedulesRef.doc(morningSchedule.id).delete().then(function () {
          data.mornings.some(function (v, i) {
            if (v.dateTime === dateTime) data.mornings.splice(i, 1)
          })
          data.showDialog = false
        })
      }
      const lunchSchedule = data.lunches.find(s => s.dateTime === dateTime)
      if (data.selectedLunch && !lunchSchedule) {
        schedulesRef.add({userId: data.userId, dateTime: dateTime, type: 'lunch'}).then(function (docRef) {
          data.lunches.push({id: docRef.id, type: 'lunch', userId: data.userId, dateTime: dateTime})
          data.showDialog = false
        })
      } else if (!data.selectedLunch && lunchSchedule) {
        schedulesRef.doc(lunchSchedule.id).delete().then(function () {
          data.lunches.some(function (v, i) {
            if (v.dateTime === dateTime) data.lunches.splice(i, 1)
          })
          data.showDialog = false
        })
      }
      const dinnerSchedule = data.dinners.find(s => s.dateTime === dateTime)
      if (data.selectedDinner && !dinnerSchedule) {
        schedulesRef.add({userId: data.userId, dateTime: dateTime, type: 'dinner'}).then(function (docRef) {
          data.dinners.push({id: docRef.id, type: 'dinner', userId: data.userId, dateTime: dateTime})
          data.showDialog = false
        })
      } else if (!data.selectedDinner && dinnerSchedule) {
        schedulesRef.doc(dinnerSchedule.id).delete().then(function () {
          data.dinners.some(function (v, i) {
            if (v.dateTime === dateTime) data.dinners.splice(i, 1)
          })
          data.showDialog = false
        })
      }
      data.showDialog = false
    }
  }
}
</script>

<style lang="sass" scoped>
.text-bold
  font-weight: bold
</style>



// WEBPACK FOOTER //
// src/components/schedules/Index.vue